export const norwegianHousehold = {
  templateId: 'household',
  language: 'no',
  name: 'Husholdning (Norsk)',
  description: 'Vanlige husholdningsartikler og rengjøringsmidler',
  icon: '🏠',
  categories: [
    {
      name: 'Rengjøringsmidler',
      items: [
        'Allrens',
        'Klorin',
        'Badrens',
        'Gulvrens',
        'Glassrens',
        'Oppvaskmiddel',
        'Tøymykner',
        'Vaskepulver',
        'Flytende vaskemiddel',
        'Flekkfjerner',
        'Toalettrens',
        'Kjøkkenspray',
        'Antibakterielle våtservietter',
        'Støvsugerposer',
        'Søppelposer'
      ]
    },
    {
      name: 'Papirvarer',
      items: [
        'Toalettpapir',
        'Kjøkkenrull',
        'Papirservietter',
        'Papirhåndklær',
        'Servietter',
        'Papirtallerkener',
        'Papirkopper',
        'Aluminiumsfolie',
        'Plastfolie',
        'Bakepapir',
        'Fryseposer',
        'Matpakkeposer'
      ]
    },
    {
      name: 'Personlig pleie',
      items: [
        'Tannkrem',
        'Tannbørste',
        'Sjampo',
        'Balsam',
        'Dusjsåpe',
        'Såpe',
        'Deodorant',
        'Barberhøvel',
        'Barberskum',
        'Fuktighetskrem',
        'Ansiktsvask',
        'Solkrem',
        'Vitaminer',
        'Aspirin',
        'Plaster'
      ]
    },
    {
      name: 'Batterier og elektronikk',
      items: [
        'AA batterier',
        'AAA batterier',
        'Mobillader',
        'Lyspærer',
        'Skjøteledning',
        'USB-kabel',
        'Minnekort',
        'Hodetelefoner',
        'Powerbank',
        'Skjermrens'
      ]
    },
    {
      name: 'Kjæledyr',
      items: [
        'Hundemat',
        'Kattemat',
        'Kjæledyrsnacks',
        'Kattesand',
        'Hundeleketøy',
        'Kjæledyrsjampo',
        'Fiskemat',
        'Fuglefrø',
        'Kjæledyrseng',
        'Bånd'
      ]
    },
    {
      name: 'Kontor og skole',
      items: [
        'Kulepenn',
        'Blyanter',
        'Notatbøker',
        'Kopipapir',
        'Blekkpatroner',
        'Stifter',
        'Binders',
        'Gule lapper',
        'Mapper',
        'Konvolutter',
        'Frimerker',
        'Tusjer',
        'Markeringspenner',
        'Linjal',
        'Viskelær'
      ]
    }
  ]
};
